import { OutletProvider } from "../outletProvider/OutletProvider";
import { IOutlet } from "./type";

export default class OutletServices {
  static async selectedServices() {
    const res = await OutletProvider.getSelectedServices();
    return res.data;
  }
  static async allServices() {
    const res = await OutletProvider.getAllServices();
    return res.data;
  }

  static async serviceDetails(params: { service_id: string | undefined }) {
    const res = await OutletProvider.getServiceDetails(params);
    return res.data;
  }
  static async CampaignData() {
    const res = await OutletProvider.getCampaign();
    return res.data;
  }
  static async ShowCamaing(id:string|undefined){
    const res=await OutletProvider.getShowCampaing(id)
    return res.data
  }
  static async MostSellerData() {
    const res = await OutletProvider.getMostSeller();
    return res.data;
  }
  static async ShowProduct(params: { id: string | undefined }) {
    const res = await OutletProvider.postShowProducts(params);
    return res.data;
  }

  static async PhonePrefixData() {
    const res = await OutletProvider.getPhonePrefix();
    return res.data;
  }
  static async AllBlogsData() {
    const res = await OutletProvider.getAllBlogsData();
    return res.data;
  }
  static async AllPartners() {
    const res = await OutletProvider.getAllPartners();
    return res.data;
  }

  static async addProductToWishlist(payload: { product_id: number }) {
    const res = await OutletProvider.postAddToWishlist(payload);
    return res.data;
  }

  static async getFavorites() {
    const res = await OutletProvider.getFavorites();
    return res.data;
  }

  static async removeFromWishlist( id: number ) {
    const res = await OutletProvider.removeFromFavorites(id);
    return res.data;
  }
  static async getOfferWeek() {
    const res = await OutletProvider.getOfferWeek();
    return res.data;
  }
  static async clearWishlist() {
    const res = await OutletProvider.clearFavorites();
    return res.data;
  }
  static async getPartnors(){
    const res=await OutletProvider.getPartnors()
    return res.data
  }
 static async getOutletHero() {
  const res = await OutletProvider.getOutletHero();
  return res.data.data as IOutlet[];
}
}
